
import ModalDetailsContentFeatures from './modal-details-content-features.vue'
import ModalDetailsContentMoreDetails from './modal-details-content-more-details/index.vue'
import Reviews from '~/components/bundle-page/kit/kit-section/kit-product-modal-details/modal-details-content-more-details/reviews.vue'
import Backdrop from '~/components/common/backdrop'
import Picture from '~/components/picture/lole-picture'
import Price from '~/components/price/price'
export default {
  components: {
    Backdrop,
    Picture,
    Price,
    ModalDetailsContentFeatures,
    ModalDetailsContentMoreDetails,
    Reviews,
  },
  inject: ['wording', 'wordingPageProduct'],
  props: {
    products: {
      type: Array,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      wording: this.wording,
    }
  },
}
